import * as React from "react";
import ReactPaginate from "react-paginate";
import * as styles from "./styled-pagination.css";
import { PaginationOptions } from "burde";

interface IStyledPaginationProps {
    numberOfPages: number;
    paginationOptions: PaginationOptions;
    setPagination: (pagination: PaginationOptions) => void;
}

const StyledPagination = (
    props: IStyledPaginationProps,
): React.ReactElement => {
    const { numberOfPages, setPagination, paginationOptions } = props;
    return (
        <ReactPaginate
            pageCount={numberOfPages}
            marginPagesDisplayed={1}
            pageRangeDisplayed={2}
            onPageChange={({ selected }) => {
                setPagination({
                    ...paginationOptions,
                    pageNumber: selected + 1,
                });
            }}
            previousLabel="&#8249;"
            nextLabel="&#8250;"
            breakLabel="..."
            breakClassName="break-me"
            containerClassName={styles.pagination}
            activeClassName={styles.active}
        />
    );
};

export { StyledPagination };
